module.exports = __webpack_public_path__ + "media/Pyjamas.c69a4fd8.mp3";